import { isResource, resolveId } from '@medplum/core'
import type { Patient, Reference, RelatedPerson } from '@medplum/fhirtypes'
import { codeFromCodeableConcept } from '#src/codeableConcept.ts'
import type { Participant } from '#src/models/patients/participant.ts'
import { ExtendedProfile } from '#src/models/profile.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class ExtendedRelatedPerson extends ExtendedProfile<RelatedPerson> {
  static readonly RESOURCE_TYPE = 'RelatedPerson'

  static isInstance(value: unknown): value is RelatedPerson {
    return isResource(value) && isOfType(value, 'RelatedPerson')
  }

  get active(): boolean | undefined {
    return this.resource.active
  }

  get relationshipCodes(): string[] | undefined {
    return this.resource.relationship?.map(
      (r) => codeFromCodeableConcept(r) ?? ''
    )
  }

  get birthDate(): string | undefined {
    return this.resource.birthDate
  }

  get patient(): Reference<Patient> {
    return this.resource.patient
  }

  protected getExportFields() {
    return {
      id: this.id,
      name: this.name,
      relationship: this.relationshipCodes,
      telecom: this.telecomSummary,
      address: this.addressSummary,
      gender: this.gender,
      birthDate: this.birthDate,
      active: this.active,
      patientId: resolveId(this.patient),
    }
  }

  static byParticipant(participant: Participant): QueryTypes {
    return {
      patient: participant,
      _sort: ['-_lastUpdated'],
    }
  }
}
